import { AxiosResponse } from 'axios'
import client, { AbortableAxiosRequestConfig } from '@/api/client'
import { BusinessItemResponse, BusinessUserResponse } from '@/dto/Business/BusinessDto'
import { DataFieldValuesRequest } from '@/dto/Business/LmsLeadDto'
import { ResponseOne } from '@/api/PaginatedResponse'
import { StoreFileDto } from '@/dto/common/files'
import { BusinessUserResponseDto } from '@/dto/Business/User/Response'

export function getBusinessesUser(
  businessId: string,
  userId: string,
  init: boolean | undefined = undefined,
): Promise<AxiosResponse<ResponseOne<BusinessUserResponseDto>>> {
  return client.get(`/business/businesses/${businessId}/users/${userId}`, <
    AbortableAxiosRequestConfig
  >{
    params: { init },
    _cannotAbort: true,
  })
}

export function getBusiness(
  businessId: string,
): Promise<AxiosResponse<ResponseOne<BusinessItemResponse>>> {
  return client.get(`/business/businesses/${businessId}`, <AbortableAxiosRequestConfig>{
    _cannotAbort: true,
  })
}

export function getBusinessInfo(
  businessId: string,
): Promise<AxiosResponse<ResponseOne<BusinessItemResponse>>> {
  return client.get(`/business/businesses/${businessId}/info`, <AbortableAxiosRequestConfig>{
    _cannotAbort: true,
  })
}

export function updateBusiness(
  businessId: string,
  business: DataFieldValuesRequest,
): Promise<AxiosResponse<ResponseOne<BusinessItemResponse>>> {
  return client.put(`/business/businesses/${businessId}`, business)
}

export function createBusinessLogo(
  businessId: string,
  file: StoreFileDto,
): Promise<AxiosResponse<ResponseOne<BusinessItemResponse>>> {
  return client.post(`/business/businesses/${businessId}/logo`, {
    file: file,
  })
}

export function deleteBusinessLogo(
  businessId: string,
): Promise<AxiosResponse<ResponseOne<BusinessItemResponse>>> {
  return client.delete(`/business/businesses/${businessId}/logo`)
}

export function getAllUsers(
  businessId: string,
): Promise<AxiosResponse<ResponseOne<{ users: BusinessUserResponse[] }>>> {
  return client.get(`/business/businesses/${businessId}/all-users`)
}
